import React from 'react';
import { GenerateHeader } from './GenerateHeader';
import { PromptStartersDesktop } from './PromptStartersDesktop';
import { PromptStartersMobile } from './PromptStartersMobile';
import { ProductMetadataSection } from './ProductMetadataSection';
import { LoraModel } from '@/types/lora';

interface GenerateLeftSidebarProps {
  product: any;
  sliderRef: React.RefObject<HTMLDivElement>;
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  setPrompt: (prompt: string) => void;
  setSelectedLoraModel: (model: LoraModel | null) => void;
}

export const GenerateLeftSidebar: React.FC<GenerateLeftSidebarProps> = ({
  product,
  sliderRef,
  textareaRef,
  setPrompt,
  setSelectedLoraModel,
}) => {
  return (
    <div className="w-full flex-shrink-0 space-y-6 xl:w-[400px]">
      <GenerateHeader
        name={product.name}
        productStatus={product.status}
        product={product}
      />

      {/* Desktop prompt starters */}
      <div className="hidden xl:block">
        <PromptStartersDesktop
          setPrompt={setPrompt}
          setSelectedLoraModel={setSelectedLoraModel}
          productPromptExamples={product.prompt_example}
        />
      </div>

      {/* Mobile prompt starters */}
      <div className="relative xl:hidden">
        <PromptStartersMobile
          sliderRef={sliderRef}
          textareaRef={textareaRef}
          setPrompt={setPrompt}
          setSelectedLoraModel={setSelectedLoraModel}
          productPromptExamples={product.prompt_example}
        />
      </div>

      {/* Product metadata - desktop only */}
      <div className="hidden xl:block">
        <ProductMetadataSection product={product} />
      </div>
    </div>
  );
};
